// @ts-strict-ignore
import { setCalculator } from '../redux/calculators/calculators-actions'
import { getCalculator } from '../redux/calculators/calculators-selectors'
import { getIncludes } from '../redux/contentful-selectors'
import { FsStore } from '../redux/helpers/create-app-store'
import { Contentful } from '../types/contentful'
import { FsCore } from '../types/fs-core'
import uuidv4 from './guid'

export function getCalculatorId(
  state: FsCore.State,
  schema: Contentful.ProductTableSchemaComponent,
) {
  if (schema.fields.schema.calculatorId) {
    return schema.fields.schema.calculatorId
  } else if (typeof schema.fields.schema.calculator === 'string') {
    return schema.fields.schema.calculator
  } else {
    const id = uuidv4()
    schema.fields.schema.calculatorId = id
    return id
  }
}
export function findCalculatorSchema(
  state: FsCore.State,
  schema: Contentful.ProductTableSchemaComponent,
): Contentful.Calculator {
  let calculatorSchema = schema.fields.schema.calculator
  if (typeof calculatorSchema === 'string') {
    calculatorSchema = findLinkedCalculatorSchema(state, calculatorSchema)
  }
  return calculatorSchema!
}

export function findOrGenerateCalculator(
  store: FsStore,
  productTableId: string,
  schema: Contentful.ProductTableSchemaComponent,
  queryParams: FsCore.QueryState,
): FsCore.CalculatorState | undefined {
  const calculatorSchema = schema.fields.schema.calculator
  let calculator: FsCore.CalculatorState | undefined
  const linkedId = schema.fields.schema.calculatorId
  if (linkedId) {
    // Should definitely exist at this point since a link id has been set
    calculator = attemptLinkToExistingCalculator(store, productTableId, linkedId)
  } else if (typeof calculatorSchema === 'string') {
    // This is a linked calculator, try to find it in the state if it has already been created for another table
    calculator = attemptLinkToExistingCalculator(store, productTableId, calculatorSchema)
    if (!calculator) {
      // If it doesn't exist, we need to create it from the linked schema in the product table
      calculator = setupLinkedCalculator(store, calculatorSchema, productTableId, schema)
    }
  } else if (typeof calculatorSchema === 'object') {
    calculator = createCalculator(
      store,
      calculatorSchema,
      productTableId,
      schema,
      queryParams,
      schema.fields.schema.calculatorId,
    )
  }
  // Set the calculator schema value in the product table schema object to replace potential string value
  schema.fields.schema.calculator = findCalculatorSchema(store.getState(), schema)
  return calculator
}

function createCalculator(
  store: FsStore,
  calculatorSchema: Contentful.Calculator,
  productTableId: string,
  tableSchema: Contentful.ProductTableSchemaComponent,
  queryParams: FsCore.QueryState,
  id?: string,
): FsCore.CalculatorState {
  if (!id) {
    id = uuidv4()
  }

  const defaultCalcInput = calculatorSchema.defaultInputs ?? {}
  Object.entries(queryParams).forEach(([key, val]) => {
    if (defaultCalcInput[key]) {
      defaultCalcInput[key] = val
    }
  })

  const calculator: FsCore.CalculatorState = {
    type: 'calculator',
    inputs: {
      ...defaultCalcInput,
    },
    id,
    usedBy: [productTableId],
  }

  store.dispatch(
    setCalculator({
      id,
      calculator,
    }),
  )
  // Set the id back in the schema in case we need to access it again
  tableSchema.fields.schema.calculatorId = calculator.id
  return calculator
}

function attemptLinkToExistingCalculator(
  store: FsStore,
  productTableId: string,
  calculatorId: string,
): FsCore.CalculatorState | undefined {
  const existingCalculator = getCalculator(store.getState(), calculatorId)
  if (existingCalculator) {
    // store.dispatch(
    //   // eslint-disable-next-line react-hooks/rules-of-hooks
    //   useCalculator({
    //     calculatorId,
    //     usedById: productTableId,
    //   }),
    // )
  }
  return getCalculator(store.getState(), calculatorId)
}

function setupLinkedCalculator(
  store: FsStore,
  calculatorId: string,
  productTableId: string,
  tableSchema: Contentful.ProductTableSchemaComponent,
): FsCore.CalculatorState | undefined {
  const calculatorSchema = findLinkedCalculatorSchema(store.getState(), calculatorId)
  if (typeof calculatorSchema === 'object' && calculatorSchema.defaultInputs) {
    // If this isn't true then someone got the reference wrong, but we don't have any good way of doing error handling
    const calculator = createCalculator(
      store,
      calculatorSchema,
      productTableId,
      tableSchema,
      calculatorId,
    )
    return calculator
  }
  return undefined
}

function findLinkedCalculatorSchema(
  state: FsCore.State,
  calculatorId: string,
): Contentful.Calculator | undefined {
  const entity: Contentful.Module<Contentful.Calculator | undefined> =
    getIncludes(state)[calculatorId]
  const calculatorSchema = entity.fields.data
  return calculatorSchema
}
